import React, { Component } from 'react';
import './css/Joke.css';
import emojiCry from '../img/svg/001-emoji.svg';
import emoji2Laugh from '../img/svg/002-emoji-1.svg';
import emojiLaugh2 from '../img/svg/003-emoji-2.svg';
import emojiMeh from '../img/svg/004-sad.svg';
import emojiFurious from '../img/svg/005-emoji-3.svg';
import emojiAnger from '../img/svg/006-emoji-4.svg';
import emojiHappy from '../img/svg/007-emoji-5.svg';
import emojiNormal from '../img/svg/008-emoji-6.svg';
import thumbUp from '../img/svg/like.svg';
import thumbDown from '../img/svg/dislike-thumb.svg';
import { setTimeout } from 'timers';

export default class Joke extends Component {
  state = {
    rate: this.props.score,
    loading: false
  };

  static defaultProps = {
    text:
      'My dog used to chase people on a bike a lot. It got so bad I had to take his bike away.'
  };

  thumbUp = () => {
    this.setState({ loading: true });

    setTimeout(() => {
      this.setState(st => {
        if (st.rate >= 15) {
          return { rate: 15, loading: false };
        } else {
          return { rate: (st.rate += 1), loading: false };
        }
      });

      this.props.setScore(this.props.id, this.state.rate + 1);
    }, 300);
  };

  thumbDown = () => {
    this.setState(() => ({ loading: true }));

    setTimeout(() => {
      this.setState(st => {
        if (st.rate <= -15) {
          return { rate: -15, loading: false };
        } else {
          return { rate: (st.rate -= 1), loading: false };
        }
      });

      this.props.setScore(this.props.id, this.state.rate - 1);
    }, 300);
  };

  chooseImg = () => {
    const { rate } = this.state;
    if (rate >= 12) {
      return emojiCry;
    } else if (rate >= 10) {
      return emojiLaugh2;
    } else if (rate >= 6) {
      return emoji2Laugh;
    } else if (rate >= 4) {
      return emojiHappy;
    } else if (rate > 0) {
      return emojiNormal;
    } else if (rate === 0) {
      return emojiMeh;
    } else if (rate <= -4) {
      return emojiAnger;
    } else {
      return emojiFurious;
    }
  };

  chooseBorder = () => {
    const { rate } = this.state;
    if (rate >= 12) {
      return 'rate-12';
    } else if (rate >= 10) {
      return 'rate-10';
    } else if (rate >= 6) {
      return 'rate-6';
    } else if (rate >= 4) {
      return 'rate-4';
    } else if (rate > 0) {
      return 'rate-4';
    } else if (rate === 0) {
      return 'rate-0';
    } else if (rate <= -4) {
      return 'rate-neg-4';
    } else {
      return 'rate-neg-15';
    }
  };

  render() {
    return (
      <div className="Joke">
        <div className="Joke-rate">
          <img
            src={thumbUp}
            className="Joke-rate-button"
            onClick={this.thumbUp}
            alt="Joke-rate-button"
          />

          <p className={`Joke-rate-text ${this.chooseBorder()}`}>
            {this.state.rate}
          </p>

          <img
            src={thumbDown}
            className="Joke-rate-button"
            onClick={this.thumbDown}
            alt="Joke-rate-button"
          />
        </div>

        <div className="Joke-text">{this.props.text}</div>

        <div className="Joke-emoji">
          <img
            className={`${this.state.loading && 'loadingSpin'}`}
            src={this.chooseImg()}
            alt="Emoji"
          />
        </div>
      </div>
    );
  }
}
